import React from 'react';
import './Sub-services.css'; // Importa los estilos CSS para este componente
import RedesBaja from './assets/BajaT.png';
const RedesBajaTensionContent = () => {
  return (
    <div className="containerSer">
      <h2>Redes de Baja Tensión</h2>
      <p>
        Las redes de baja tensión son aquellas que transportan y distribuyen
        energía eléctrica desde la red pública o transformadores hasta las
        instalaciones internas de edificaciones. Operan normalmente en niveles
        de voltaje inferiores a 1000V (como 120V, 220V o 440V) y son
        fundamentales para garantizar un suministro seguro y confiable. Estas
        redes deben diseñarse e instalarse según los estándares técnicos
        establecidos por el RETIE y las especificaciones del operador de red.
      </p>

      <div className="image">
        <img src={RedesBaja} alt="Servicios en redes de baja tensión" />
      </div>

      <p>
        Ofrecemos el servicio de diseño, instalación y legalización de redes de
        baja tensión para proyectos residenciales, comerciales, industriales y
        rurales. Aseguramos una distribución segura, eficiente y conforme a los
        requisitos del operador de red y del RETIE; este servicio te incluye:
        estudio técnico y levantamiento en sitio, diseño eléctrico con planos y
        memorias técnicas, suministro e instalación de postes, cables,
        acometidas y protecciones, Adecuación de transformadores y tableros
        generales (si se requiere); Trámites ante el operador de red y
        certificación RETIE, pruebas de puesta en servicio y legalización.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>Suministro eléctrico confiable y continuo.</li>
        <li>Cumplimiento de normativas técnicas exigidas en Colombia.</li>
        <li>Tranquilidad al dejar todo en manos de expertos.</li>
        <li>Seguridad en la infraestructura eléctrica de tu proyecto.</li>
      </ul>
    </div>
  );
};

export default RedesBajaTensionContent;
